export default __webpack_public_path__ + "static/media/img_step_hami09.62cb2b55.png";